// extracted by mini-css-extract-plugin
export var footer = "_rh-0";
export var inherit = "_rh-1";
export var input = "_rh-2";
export var modalContent = "_rh-3";
export var quillEditor = "_rh-4";
export var subtitle = "_rh-5";